import type { JSX } from 'react';

import { useWagers } from '../api/stakes.ts';
import { Card } from '../ui/Card.tsx';
import { EntryList } from '../ui/EntryList.tsx';
import { WagerEntry } from './WagerEntry.tsx';

/**
 * Wagers somebody else offered and nobody answered yet. Nothing renders when there are none:
 * the first screen only shows what needs doing.
 */
export function WagersNeedingAnswer(): JSX.Element | null {
  const wagers = useWagers();
  const waiting = (wagers.data ?? []).filter(
    (wager) => wager.role === 'counterparty' && wager.status === 'proposed',
  );

  if (waiting.length === 0) {
    return null;
  }

  return (
    <Card title="Needs your answer" description="A wager is on once you accept it, and not before.">
      <EntryList label="Wagers needing an answer">
        {waiting.map((wager) => (
          <WagerEntry key={wager.id} wager={wager} />
        ))}
      </EntryList>
    </Card>
  );
}
